export default __webpack_public_path__ + "static/media/ENEBULA.a211391e.jpg";